export default __webpack_public_path__ + "static/media/wa-background-dark.4c52474f.png";